(function () {
  var SECTION_SELECTOR = '[data-product-reviews]';
  var REVIEW_SELECTOR = '.jm-review-item, .jm-review, .jdgm-rev';
  var WIDGET_SELECTOR = '#judgeme_product_reviews, .jm-reviews-widget, .jdgm-rev-widg';
  var ACTION_SELECTOR = 'button, [role="button"], select, input[type="radio"], input[type="checkbox"]';
  var WRITE_REVIEW_SELECTOR = [
    '.jm-write-review-button',
    '.jm-action-buttons__button',
    '.jdgm-write-rev-link',
    '[data-testid*="write-review"]',
    '[data-testid*="write_review"]'
  ].join(', ');

  function isVisible(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function getWidget(section) {
    return section.querySelector(WIDGET_SELECTOR);
  }

  function getNativeWriteButton(section) {
    var app = section.querySelector('[data-review-app]');
    if (!app) return null;

    var exactMatch = app.querySelector(WRITE_REVIEW_SELECTOR);
    if (exactMatch) return exactMatch;

    return Array.prototype.find.call(app.querySelectorAll('button, a'), function (candidate) {
      var label = [
        candidate.textContent,
        candidate.getAttribute('aria-label'),
        candidate.getAttribute('title'),
        candidate.className
      ].join(' ');

      return /write\s*(a\s*)?review|review\s*write|写.*评|撰写.*评|留下.*评/i.test(label);
    }) || null;
  }

  function getVisibleReviewCount(section) {
    return Array.prototype.filter.call(section.querySelectorAll(REVIEW_SELECTOR), isVisible).length;
  }

  function hasUsefulWidgetContent(section) {
    var widget = getWidget(section);
    if (!widget || !isVisible(widget)) return false;
    if (getVisibleReviewCount(section) > 0) return true;

    return Boolean(widget.querySelector([
      WRITE_REVIEW_SELECTOR,
      '.jdgm-rev-widg__summary',
      'form'
    ].join(', ')));
  }

  function syncFallback(section) {
    var fallback = section.querySelector('[data-review-fallback]');
    if (!fallback) return;
    fallback.hidden = hasUsefulWidgetContent(section);
  }

  function syncWriteButton(section, finalCheck) {
    var button = section.querySelector('[data-review-write]');
    if (!button) return;

    var nativeButton = getNativeWriteButton(section);
    var help = section.querySelector('[data-review-write-help]');

    if (nativeButton) {
      button.hidden = false;
      button.disabled = false;
      button.dataset.reviewWriteReady = 'true';
      if (help) help.hidden = true;
      return;
    }

    button.disabled = true;
    button.dataset.reviewWriteReady = 'false';

    if (finalCheck) {
      if (section.dataset.designMode === 'true') {
        button.hidden = false;
        if (help) help.hidden = false;
      } else {
        button.hidden = true;
      }
    }
  }

  function announceVisibleCount(section) {
    var status = section.querySelector('[data-review-status]');
    if (!status) return;

    window.setTimeout(function () {
      var count = getVisibleReviewCount(section);
      var label = count === 1 ? section.dataset.reviewSingular : section.dataset.reviewPlural;
      status.textContent = count > 0 ? count + ' ' + label : section.dataset.reviewEmptyStatus;
    }, 80);
  }

  function syncReviewPreview(section) {
    var params = new URLSearchParams(window.location.search);
    var expanded = params.get('reviews') === 'all';
    var limit = Number(section.dataset.reviewPreviewLimit) || 3;
    var reviews = Array.prototype.slice.call(section.querySelectorAll(REVIEW_SELECTOR));
    var total = Number(section.dataset.reviewTotal) || 0;
    var viewAll = section.querySelector('[data-review-view-all]');
    var back = section.querySelector('[data-review-back]');
    var renderedCount = reviews.length;
    var effectiveCount = Math.max(total, renderedCount);

    section.dataset.reviewExpanded = expanded ? 'true' : 'false';
    section.dataset.reviewRenderedCount = String(renderedCount);
    section.classList.toggle('product-reviews--has-reviews', effectiveCount > 0);
    section.classList.toggle('product-reviews--single-review', effectiveCount === 1);

    reviews.forEach(function (review, index) {
      if (!expanded && index >= limit) {
        review.setAttribute('data-review-preview-hidden', 'true');
      } else {
        review.removeAttribute('data-review-preview-hidden');
      }
    });

    if (viewAll) viewAll.hidden = expanded || effectiveCount <= limit;
    if (back) back.hidden = !expanded;
  }

  function activateNativeWriteButton(section, nativeButton) {
    var previousScrollY = window.scrollY;

    function restoreReviewPosition() {
      var jumpedToTop = previousScrollY > 80 && window.scrollY < 40;
      if (jumpedToTop) {
        window.scrollTo({ top: previousScrollY, behavior: 'auto' });
      }
    }

    nativeButton.addEventListener('click', function (event) {
      event.preventDefault();
    }, { once: true });

    nativeButton.click();

    window.requestAnimationFrame(restoreReviewPosition);
    window.setTimeout(restoreReviewPosition, 160);
    window.setTimeout(restoreReviewPosition, 640);
  }

  function initSection(section) {
    if (section.dataset.reviewUiReady === 'true') return;
    section.dataset.reviewUiReady = 'true';
    syncReviewPreview(section);

    [0, 400, 2400, 5000].forEach(function (delay, index, delays) {
      window.setTimeout(function () {
        syncFallback(section);
        syncWriteButton(section, index === delays.length - 1);
        syncReviewPreview(section);
      }, delay);
    });

    section.addEventListener('click', function (event) {
      var writeButton = event.target.closest('[data-review-write]');
      if (writeButton) {
        var nativeButton = getNativeWriteButton(section);
        if (nativeButton) activateNativeWriteButton(section, nativeButton);
        return;
      }

      if (event.target.closest(ACTION_SELECTOR)) announceVisibleCount(section);
    });

    section.addEventListener('change', function (event) {
      if (event.target.matches(ACTION_SELECTOR)) announceVisibleCount(section);
    });

    var app = section.querySelector('[data-review-app]');
    if (app && 'MutationObserver' in window) {
      new MutationObserver(function () {
        syncFallback(section);
        syncWriteButton(section, false);
        syncReviewPreview(section);
      }).observe(app, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'hidden', 'aria-hidden', 'style']
      });
    }
  }

  function init(root) {
    var scope = root || document;
    if (scope.matches && scope.matches(SECTION_SELECTOR)) initSection(scope);
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
